export const updateAuthToken = (token: string) => {
  $('meta[name=csrf-token]').attr('content', token);
};

export default {
  updateAuthToken
};
